import React, { useState } from "react";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { Table, Modal } from "react-bootstrap";
import { EmailManagementActions } from "../../redux";
import BasicPagination from "../../../pagination/BasicPagination";
import { useHistory } from "react-router-dom";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../../../_metronic/_helpers";
import { deleteEmailAsync } from "../../redux/emailManagementApi";
import { CircularProgress } from "@material-ui/core";

const EmailManagementTable = ({ onEditClick }) => {
  const { isLoading, emailList, skip, limit } = useSelector(
    (state) => state.emailManagement,
    shallowEqual
  );

  const history = useHistory();
  const [DeleteModal, setDeleteModal] = useState(false);
  const deleteClose = () => setDeleteModal(false);
  const deleteShow = () => setDeleteModal(true);
  const dispatch = useDispatch();
  const [selectedEmailName, setselectedEmailName] = useState({});
  //on page change 
  const onPageChange = (currentBatch) => {
    let count = currentBatch ? currentBatch - 1 : skip;
    dispatch(EmailManagementActions.setEmailBatchNumber(count));
  };
  //show delete model and save delete email id
  const onDeleteClick = (emailLists) => {
    setselectedEmailName(emailLists);
    deleteShow();
  };
  //call delete email api and close delete model
  const onDeactiveClick = () => {
    dispatch(deleteEmailAsync(selectedEmailName._id));
    setselectedEmailName({});
    deleteClose();
  };
  const onActivateClick = (emailLists) => {
    dispatch(deleteEmailAsync(emailLists._id));
  };

  return (
    <div className="px-6 pt-0 dash_wt_bx pb-0 ovflhddn loader-display-position">
      <div className="tblmrgn mt-0">
        <div className="mt-5">
          <div>
            <Table
              hover
              responsive
              className="mb-0 default_table with_hoverbtn mrpdng_tbl"
            >
              <thead>
                <tr>
                  <th>Sr No.</th>
                  <th>Title</th>
                  <th>Subject</th>
                  <th width="120px">Action</th>
                </tr>
              </thead>
              <tbody>
                {emailList.data && emailList.data.email.length ? (
                  emailList.data.email.map((emailLists, index) => (
                    <tr key={index}>
                      <td>
                        <span className="f-w-500">
                          {skip * limit + (index + 1)}
                        </span>
                      </td>
                      <td>
                        <span className="f-w-500">{emailLists.mailTitle}</span>
                      </td>
                      <td>{emailLists.mailSubject}</td>

                      <td>
                        <a
                          title="Edit"
                          className="btn btn-icon btn-light btn-hover-primary btn-sm mr-3"
                          onClick={() => onEditClick(emailLists)}
                        >
                          <span className="svg-icon svg-icon-md svg-icon-primary">
                            <SVG
                              src={toAbsoluteUrl(
                                "/media/svg/icons/Communication/Write.svg"
                              )}
                            />
                          </span>
                        </a>
                        <a
                          title="Delete"
                          className="btn btn-icon btn-light btn-hover-danger btn-sm"
                          onClick={() => onDeleteClick(emailLists)}
                        >
                          <span className="svg-icon svg-icon-md svg-icon-danger">
                            <SVG
                              src={toAbsoluteUrl(
                                "/media/svg/icons/General/Trash.svg"
                              )}
                            />
                          </span>
                        </a>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={8} className="text-center">
                      No Record Found
                    </td>
                  </tr>
                )}
                {isLoading && (
                  <tr>
                    <td colSpan={8} className="text-center">
                      <div className="basic-verification-loader text-center">
                        <CircularProgress />
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </div>
          
            <div className="row d-flex align-items-center mr-5 ml-5 mt-4 btm-pagination">
              <div className="col-md-4 mb-5 fn_s_16 f-w-400 text-left">
                Displaying {skip * limit + 1} - {skip * limit + limit} of{" "}
                {emailList.recordsTotal} Records
              </div>
              <div className="col-md-8 text-left mb-5 aspgntn">
                <BasicPagination
                  totalRecords={emailList.recordsTotal}
                  limit={limit}
                  batch={skip + 1}
                  onBatchChange={onPageChange}
                />
              </div>

            </div>
          
        </div>
      </div>
      <Modal
        show={DeleteModal}
        onHide={deleteClose}
        centered
        className="def_modal delete_modal"
      >
        <Modal.Header>
          <Modal.Title className="fn_s_18 color_blk f-w-700">Alert</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form className="form def_form frmwtpddng">
            <p className="fn_s_18 f-w-400 text-center mb-10">
              Are you sure want to delete?
            </p>
            <div className="form-group d-flex flex-wrap justify-content-center align-items-center mb-0">
              <div className="form-group mr-5 mb-1 mt-2">
                <button
                  className="btn_new btn-sm"
                  type="button"
                  onClick={deleteClose}
                >
                  Close
                </button>
              </div>
              <div className="form-group mr-5 mb-1 mt-2">
                <button
                  className="btn_new btn-sm"
                  type="button"
                  onClick={onDeactiveClick}
                >
                  Yes, Delete it
                </button>
              </div>
            </div>
          </form>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default EmailManagementTable;
